import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ConfigurationResponse {
  employeeNames: string[];
  sparePartDeliveryStatus: string[];
  orderStatus: string[];
  shippingSparePartOptions: string[];
  packageStates: PackageStatesConfig;
}

export interface PackageStatesConfig {
  packagedForShipping: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private readonly baseUrl = `${environment.apiEndpoint}/api/configuration`;
  private readonly http = inject(HttpClient);

  getAllConfigurations(): Observable<ConfigurationResponse> {
    return this.http.get<ConfigurationResponse>(`${this.baseUrl}/all`);
  }

  getEmployeeNames(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/employee-names`);
  }

  getSparePartDeliveryStatus(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/spare-part-delivery-status`);
  }

  getOrderStatus(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/order-status`);
  }

  getShippingSparePartOptions(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/shipping-spare-part-options`);
  }

  getPackageStates(): Observable<PackageStatesConfig> {
    return this.http.get<PackageStatesConfig>(`${this.baseUrl}/package-states`);
  }

  // Métodos de validación
  validateEmployeeName(employeeName: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/validate-employee-name`, employeeName);
  }

  validateSparePartStatus(status: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/validate-spare-part-status`, status);
  }

  validateOrderStatus(status: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/validate-order-status`, status);
  }
} 